import { IBackTestSearchParams } from "src/Interfaces/deltaHedgeBackTest";
import { getBorderTable } from "src/Requests/deltaHedgeBackTest";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { TableAdditional } from "./Additional";

interface IProps {
  searchParams: IBackTestSearchParams;
  setRefreshBorderGraph: (flag: boolean) => void;
}

const BorderTable = ({ searchParams, setRefreshBorderGraph }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={() => {
            if (onAction) onAction();
            setRefreshBorderGraph(true);
          }}
          AdditionalBody={TableAdditional}
        />
      )}
      getDataTable={getBorderTable}
      searchParameters={searchParams}
    />
  );
};

export default BorderTable;
